// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log("Vite ⚡️ Rails");

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails"
);

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import * as Turbo from "@hotwired/turbo";
import { cable } from "@hotwired/turbo-rails";
import { createConsumer } from "@rails/actioncable/src";
import "@rails/request.js";

// Manually create and inject ActionCable consumer.
// turbo-rails uses a dynamic import("@rails/actioncable/src") internally
// which fails in Vite dev mode (bare specifier not resolvable at runtime).
// Static import + setConsumer bypasses the broken dynamic import.
// Exposed globally so Stimulus controllers (e.g. user-channel) can reuse it.
const consumer = createConsumer();
cable.setConsumer(consumer);
window._cableConsumer = consumer;

// GO4S DS — toutes les confirmations data-turbo-confirm passent par la modale
// de confirmation du design system (les suppressions en variante destructive).
import { turboConfirm } from "../utils/ds_confirm.js";
Turbo.config.forms.confirm = turboConfirm;
import "../stylesheets/teachers/dashboard.css";
import "../stylesheets/teachers/timetables.css";
import "./application.css";
import "./controllers";
// 🔴 **`window.Notify` / `window.Toast`** — extraite de `notification_controller.js`
// le 2026-09-21. Elle y voyageait avec la classe Stimulus, et partait donc dans
// TOUT paquet qui enregistrait le contrôleur : GO4LEARN l'a payée +1 597 octets gz
// sur le budget d'une page apprenante pour une usine qu'il n'appelle jamais.
// ⚠️ Import pour son EFFET DE BORD (elle pose les deux globales), pas pour une valeur.
import "../utils/notify.js";
/* Habillage du site vitrine (partie déconnectée) */
import "../stylesheets/public_site.css";
/* Import documentation-specific styles */
import "../stylesheets/documentation.css";
import "../stylesheets/documentation_v2.css";
/* Import documentation search controller */
import documentationSearch from "../controllers/documentation_search_controller.js";

import "flatpickr/dist/flatpickr.css";
import "../stylesheets/flatpickr-custom.css";
import "../stylesheets/pilot.css";
import "../stylesheets/design_system.css";
import "../stylesheets/ds_components.css";
import "../stylesheets/ds_scheme_of_work.css";
import "../stylesheets/ds_news.css";
import "../stylesheets/ds_bulk_upload.css";
import "../stylesheets/timetable.css";
import "driver.js/dist/driver.css";
import "../stylesheets/ds_tour.css";
import "../stylesheets/ds_navgroups.css";

import i18n from "../i18n/translations.js";
import Chart from "chart.js/auto";
import "../services/translation_service.js";
import { chartPalette, chartStroke } from "../utils/chart_colors.js";

// GO4S Design System — moteur d'icônes Lucide (jeu d'icônes officiel du DS).
// Remplace tous les <i data-lucide="nom"> par leur SVG, au chargement et après
// chaque navigation Turbo / rendu de frame. Spec : docs/design-system/REFERENCE.md §3.
import { createIcons, icons as lucideIcons } from "lucide";
const renderLucide = () => {
  try {
    createIcons({ icons: lucideIcons, attrs: { "stroke-width": 2, "aria-hidden": "true" } });
  } catch (_) { /* no-op si aucun <i data-lucide> présent */ }
};
document.addEventListener("DOMContentLoaded", renderLucide);
document.addEventListener("turbo:load", renderLucide);
document.addEventListener("turbo:frame-load", renderLucide);
// A page refresh by morph (e.g. the report progress) puts the <i data-lucide> back.
document.addEventListener("turbo:morph", renderLucide);
// Les Turbo Streams (append/replace de modales, toasts…) ne déclenchent pas
// turbo:load/frame-load : on re-rend les icônes après chaque application de stream.
document.addEventListener("turbo:before-stream-render", (event) => {
  const fallbackRender = event.detail.render;
  event.detail.render = async (streamElement) => {
    await fallbackRender(streamElement);
    renderLucide();
  };
});
window.g4sRenderIcons = renderLucide;

// Windows : les graphiques retombaient sur Arial (la police par défaut de
// Chart.js, Helvetica Neue, n'existe que sur Mac). Même police que le reste de
// l'interface, sur tous les systèmes.
Chart.defaults.font.family = '"DM Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

// Windows et Linux : la touche du raccourci de recherche est Ctrl, pas ⌘.
const localizeShortcutBadges = () => {
  if (/Mac|iPhone|iPad/.test(navigator.platform)) return;
  document.querySelectorAll("kbd").forEach((badge) => {
    if (badge.textContent.includes("⌘")) badge.textContent = badge.textContent.replace("⌘", "Ctrl ");
  });
};
document.addEventListener("DOMContentLoaded", localizeShortcutBadges);
document.addEventListener("turbo:load", localizeShortcutBadges);
document.addEventListener("turbo:frame-load", localizeShortcutBadges);
// Le HTML injecté hors Turbo (listes rechargées par fetch + innerHTML, champs
// ajoutés à la volée) ne déclenche aucun des événements ci-dessus : ses
// icônes restaient des carrés vides (les « ⋮ » d'une liste de frais filtrée
// par type). On les dessine dès qu'un <i data-lucide> apparaît dans la page,
// une fois par image affichée. createIcons remplace le <i> par un <svg> : la
// mutation qu'il provoque n'ajoute plus de <i> et ne relance rien.
let lucidePending = false;
new MutationObserver((mutations) => {
  if (lucidePending) return;
  const added = mutations.some((m) => Array.from(m.addedNodes).some((node) =>
    node.nodeType === 1 && (node.matches("i[data-lucide]") || node.querySelector("i[data-lucide]"))));
  if (!added) return;
  lucidePending = true;
  requestAnimationFrame(() => { lucidePending = false; renderLucide(); });
}).observe(document.documentElement, { childList: true, subtree: true });

// GO4S Design System — palette de graphiques (utils/chart_colors.js), exposée
// en global pour les vues qui construisent leurs Chart.js inline.
window.g4sChartPalette = chartPalette;
window.g4sChartStroke = chartStroke;

// GO4S Design System — toasts dynamiques. window.g4sToast({ tone, title, message }).
// Spec : docs/design-system/REFERENCE.md §4
window.g4sToast = ({ tone = "info", title = "", message = "" } = {}) => {
  let stack = document.querySelector(".ds-toast-stack");
  if (!stack) {
    stack = document.createElement("div");
    stack.className = "ds-toast-stack";
    // Région live : les toasts injectés sont annoncés par les lecteurs d'écran.
    stack.setAttribute("aria-live", "polite");
    stack.setAttribute("aria-atomic", "false");
    document.body.appendChild(stack);
  }
  const icons = { success: "check-circle", danger: "alert-circle", warning: "alert-triangle", info: "info" };
  const el = document.createElement("div");
  el.className = `ds-toast ds-toast--${tone}`;
  el.setAttribute("data-controller", "ds-toast ds-dismiss");
  // danger/warning interrompent (alert) ; le reste est poli (status).
  el.setAttribute("role", tone === "danger" || tone === "warning" ? "alert" : "status");
  el.setAttribute("aria-atomic", "true");
  el.innerHTML =
    `<span class="ds-toast__bar"></span>` +
    `<span class="ds-toast__icon"><i data-lucide="${icons[tone] || "info"}" class="ds-icon"></i></span>` +
    `<div class="ds-toast__body">` +
    (title ? `<div class="ds-toast__title">${title}</div>` : "") +
    (message ? `<div class="ds-toast__desc">${message}</div>` : "") +
    `</div>` +
    `<button type="button" class="ds-toast__close" data-action="ds-dismiss#close" aria-label="Fermer"><i data-lucide="x" class="ds-icon"></i></button>`;
  stack.appendChild(el);
  renderLucide();
};

// Register Alpine components before Alpine starts
if (typeof window !== "undefined") {
  window.documentationSearch = documentationSearch;
  window.Chart = Chart; // Make Chart.js globally available
}

window.t = (key, options) => i18n.translate(key, {
  ...(options || {}),
  locale: document.querySelector("meta[name='current-locale']")?.getAttribute("content") || "fr",
  defaultLocale: document.querySelector("meta[name='current-locale']")?.getAttribute("content") || "fr",
});

// Expose I18n instance globally for controllers
window.I18n = i18n;
// Expose Turbo globally
window.Turbo = Turbo;

// Custom Turbo Stream action: append only if element not already present
// Used by chat broadcast — sender already has the message via form response
Turbo.StreamActions.append_if_missing = function () {
  this.targetElements.forEach((target) => {
    const el = this.templateContent.firstElementChild;
    if (el && document.getElementById(el.id)) return;
    target.appendChild(this.templateContent.cloneNode(true));
    target.scrollTop = target.scrollHeight;
  });
};

// Start Turbo
Turbo.start();

window.Turbo.StreamActions.update_input = function () {
  this.targetElements.forEach((target) => {
    const value = this.templateContent.textContent;
    target.value = value;
  });
};

// Register Alpine components BEFORE Alpine starts (Alpine is loaded via CDN with defer)
document.addEventListener("alpine:init", () => {
  window.Alpine.data("documentationSearch", documentationSearch);
});

document.addEventListener("turbo:load", () => {
  if (window.Turbo) {
    window.Turbo.StreamActions.update_input = function () {
      this.targetElements.forEach((target) => {
        const value = this.templateContent.textContent;
        target.value = value;
      });
    };

    // Action personnalisée pour fermer les modals via l'événement attendu par les controllers locaux
    window.Turbo.StreamActions.close_modal = function () {
      document.dispatchEvent(new CustomEvent("closeModal"));
      document.dispatchEvent(new CustomEvent("modal:closed"));
      window.dispatchEvent(new CustomEvent("modal:close"));
    };
  }
});
